import React from "react";
import { useTheme } from "@/context/ThemeContext";
import { useLang } from "@/context/LanguageContext";
import { Monitor, Sun, Moon } from "lucide-react";

const OPTIONS = [
  { value: "system", Icon: Monitor, key: "theme_system" },
  { value: "light", Icon: Sun, key: "theme_light" },
  { value: "dark", Icon: Moon, key: "theme_dark" },
];

export function ThemeSwitcher({ className = "", showLabels = false }) {
  const { theme, setTheme } = useTheme();
  const { t } = useLang();
  return (
    <div
      data-testid="theme-switcher"
      className={`inline-flex items-center gap-0.5 rounded-full border border-white/10 p-0.5 ${className}`}
    >
      {OPTIONS.map(({ value, Icon, key }) => {
        const active = theme === value;
        return (
          <button
            key={value}
            onClick={() => setTheme(value)}
            data-testid={`theme-option-${value}`}
            aria-label={t(key)}
            title={t(key)}
            className={`inline-flex items-center justify-center gap-1.5 h-7 rounded-full transition-colors ${showLabels ? "px-3 text-xs" : "w-7"} ${
              active ? "gradient-brand text-brand-navy font-semibold" : "text-slate-400 hover:text-brand-cyan"
            }`}
          >
            <Icon className="h-3.5 w-3.5" />
            {showLabels && <span>{t(key)}</span>}
          </button>
        );
      })}
    </div>
  );
}
